
export enum ShipmentServiceTypeCd {
	CON_WAY_DEFERRED_EXPRESS = 'ConWayDeferredExpress',
	GUARANTEED_BY_12_NOON = 'GuaranteedBy12Noon',
	LTL_EXPEDITE_SERVICE = 'LtlExpediteService',
	NORMAL_LTL = 'NormalLtl'}

